import React from 'react';
import { TextField } from '@mui/material';

const QuickCheckNameRow = ({ formFields, required, formValues, processing, onChange, onBlur, isInvalid }) => (
  <div className="flex-row">
    <TextField
      label="First Name"
      name={formFields.firstName}
      id={formFields.firstName}
      required={required}
      disabled={processing}
      type="text"
      maxLength="100"
      value={formValues[formFields.firstName] || ''}
      onChange={onChange}
      onBlur={onBlur}
      variant="outlined"
      className="text-field"
      fullWidth
      error={!!isInvalid[formFields.firstName]}
      helperText={isInvalid[formFields.firstName]}
    />
    <TextField
      label="Last Name"
      name={formFields.lastName}
      id={formFields.lastName}
      required={required}
      disabled={processing}
      type="text"
      maxLength="100"
      value={formValues[formFields.lastName] || ''}
      onChange={onChange}
      onBlur={onBlur}
      variant="outlined"
      className="text-field"
      fullWidth
      error={!!isInvalid[formFields.lastName]}
      helperText={isInvalid[formFields.lastName]}
    />
  </div>
);

export default QuickCheckNameRow;
